import { render, staticRenderFns } from "./InventoryTrace.vue?vue&type=template&id=bb66868c&scoped=true&"
import script from "./InventoryTrace.vue?vue&type=script&lang=js&"
export * from "./InventoryTrace.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTrace.vue?vue&type=style&index=0&id=bb66868c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb66868c",
  null
  
)

export default component.exports